import React from "react";
import {observer} from "mobx-react-lite";
import PhoneInput from "react-phone-input-2";

import systemStore from "../storage/SystemStore";

import "react-phone-input-2/lib/style.css";


const Phone = ({
    value,

    store,
    prop,

    country = "kg",

    valid,
    required = false,
    invalid: invalidProp,

    disabled = false,

    inputClass = "",
    containerClass = "",

    onChange,

    inputProps = {},

    ...rest
}) => {

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const currentValue =
        value !== undefined
            ? value
            : storeBound
                ? store[prop]
                : "";


    const getValidity = () => {
        if (typeof valid === "function") {
            return valid(
                currentValue,
                store
            );
        }

        if (typeof valid === "string") {
            return store?.[valid];
        }

        return valid;
    };


    const validity =
        getValidity();


    const invalid =
        invalidProp ??
        (
            storeBound &&
            Boolean(store?.was_validated) &&
            (
                (
                    required &&
                    !currentValue
                ) ||
                (
                    Boolean(currentValue) &&
                    validity === false
                )
            )
        );


    const isDisabled =
        disabled ||
        systemStore.loading;


    const handleChange = (
        phone,
        countryData,
        event,
        formattedValue
    ) => {

        if (storeBound) {
            store.setProperty(
                prop,
                phone
            );
        }


        onChange?.(
            phone,
            countryData,
            event,
            formattedValue
        );
    };


    const finalInputClass = [
        invalid && "invalid",
        inputClass,
    ]
        .filter(Boolean)
        .join(" ");


    const finalContainerClass = [
        "phone-input-container",
        containerClass,
    ]
        .filter(Boolean)
        .join(" ");


    return (
        <PhoneInput
            {...rest}

            country={country}

            value={
                currentValue || ""
            }

            disabled={isDisabled}

            inputClass={
                finalInputClass
            }

            containerClass={
                finalContainerClass
            }

            inputProps={{
                ...inputProps,

                required,

                "aria-invalid":
                    invalid
                        ? "true"
                        : undefined,
            }}

            onChange={
                handleChange
            }
        />
    );
};


export default observer(Phone);